import React from "react";

interface DottedDetailProps {
    label: string;
    detail?: string;
    defaultLength?: number;
    afterText?: string;
    detailCenter?: boolean;
    disabledDotted?: boolean;
    subLabel?: string;
}

const DottedDetail: React.FC<DottedDetailProps> = ({
    label,
    detail = "",
    defaultLength = 10,
    detailCenter,
    disabledDotted,
    subLabel
}) => {
    // คำนวณความยาวของจุดตาม detail หรือ defaultLength ที่มากกว่า
    const length = Math.max(detail.length, defaultLength);
    const dots = ".".repeat(length);

    return (
        <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ marginRight: "8px" }}>
                <div className="flex flex-col gap-1">
                    <span className="text-[1rem] font-normal">
                        {label}
                    </span>
                    {subLabel && (<span className="mt-[-0.7rem]">{subLabel}</span>)}
                </div>
            </div>
            <div style={{ flexGrow: 1, position: "relative" }}>
                {!disabledDotted && (
                    <span style={{ display: "block", width: "100%" }}>
                        <span style={{ position: "absolute", bottom: detail ? "-0.3em" : "-1.2em", left: 0 }}>{dots}</span>
                    </span>
                )}
                <div style={{ position: "relative" }}>
                    <span className={`text-[1rem] font-normal  ${detailCenter && 'flex justify-center text-center'}`}> {detail}</span>
                </div>
            </div>
        </div>
    );
};

export default DottedDetail;
